import { isArray } from 'lodash';

export const SET_FORM_FIELD_VALUE = 'SET_FORM_FIELD_VALUE';
export const setFormFieldValue = (form, field, value) => ({
    type: SET_FORM_FIELD_VALUE,
    form,
    field,
    value,
});

export const SET_FORM_FIELD_ERROR_MESSAGE = 'SET_FIELD_ERROR_MESSAGE';
export const setFieldErrorMessage = (form, field, errorMessage) => ({
    type: SET_FORM_FIELD_ERROR_MESSAGE,
    form,
    field,
    errorMessage,
});

export const SET_FORM_FIELD_VALID = 'SET_FORM_FIELD_VALID';
export const setFormFieldValid = (form, field, isValid) => ({
    type: SET_FORM_FIELD_VALID,
    form,
    field,
    isValid,
});

export const handleRequestErrors = (form, formattedResponse, dispatch) => {
    const { errors } = formattedResponse;
    errors.forEach(({
        field,
        message,
    }) => {
        if (isArray(field)) {
            field.forEach((name) => {
                dispatch(setFieldErrorMessage(form, name, message));
            });
        } else {
            dispatch(setFieldErrorMessage(form, field, message));
        }
    });
};
